import { createState } from '../../lib/create-state';

import { BingoJackpotWinnerMessage } from '../../types/bingo-events/in/backend/jackpot-winner-message';
import { meta } from './meta';

export type JackpotWinnerState = BingoJackpotWinnerMessage | null;

export const DEFAULT_JACKPOT_WINNER_STATE: JackpotWinnerState = null;

export const [jackpotWinner, resetJackpotWinner] =
    createState<JackpotWinnerState>(DEFAULT_JACKPOT_WINNER_STATE);

export const closeJackpotModal = () => {
    meta.modals.jackpot.set(false);
    resetJackpotWinner();
};
